import { z } from "zod";

/**
 * Base schema untuk response API yang konsisten, dengan data utama `data` yang bisa di-override
 * dan beberapa atribut umum seperti `success`, `message`, dan `code`.
 * Pengguna bisa menambahkan field lain seperti `pagination`, `meta`, dll.
 */
export const BaseResponseSchema = z.object({
    success: z.boolean(), // Status dari response (apakah sukses?)
    message: z.string(),  // Pesan yang menyertainya (misal: "Data berhasil dimuat")
    code: z.number(), // Kode status (misal: 200 untuk sukses, 400 untuk error)
    data: z.any(), // `data` bisa berupa apa saja, sesuai yang diperlukan untuk setiap response
});
